<app-modal
  [title]="title()"
  [subtitle]="subtitle()"
  [submitText]="submitText()"
  [closeText]="closeText()"
  [loading]="loading()"
  (submitClicked)="submitClicked.emit()">
  <div class="d-flex flex-column gap-3" [formGroup]="formGroup()">
    @if (errorMessage()) {
      <div class="alert alert-danger mb-0" role="alert">{{ errorMessage() | translate }}</div>
    }
    <ng-content></ng-content>
  </div>
</app-modal>
